/**
 * @module TagManager
 */

/**
 * Track tags as strings.
 * 
 * @class TagManager
 */
const TagManager = class {
    constructor () {

        /**
         * List of tags
         * @private
         */
        this._tags = [];
    }

    /**
     * Add a tag, if it does not already exist.
     * @param {String} tag - Tag to add
     */
    add ( tag ) {
        if ( !this.has( tag ) ) {
            this._tags.push( tag );
        }
    }

    /**
     * Remove all tags.
     */
    clear () {
        this._tags = [];
    }

    /**
     * Return whether the given tag exists.
     * @param {String} tag - Tag to check
     * @return {Boolean}
     */
    has ( tag ) {
        return this._tags.indexOf( tag ) > -1;
    }

    /**
     * Remove the tag.
     * @param {String} tag - Tag to remove
     */
    remove ( tag ) {
        let index = this._tags.indexOf( tag );
        if ( index > -1 ) {
            this._tags.splice( index, 1 );
        }
    }
};

export default TagManager;
